export default __webpack_public_path__ + "static/media/character-2.d296013c.png";